import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=29923fac&scoped=true"
import script from "./deliver.vue?vue&type=script&lang=js"
export * from "./deliver.vue?vue&type=script&lang=js"
import style0 from "./deliver.vue?vue&type=style&index=0&id=29923fac&prod&scoped=true&lang=css"
import style1 from "./deliver.vue?vue&type=style&index=1&id=29923fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29923fac",
  null
  
)

export default component.exports